import { render, staticRenderFns } from "./batchGather.vue?vue&type=template&id=446881ab&scoped=true&"
import script from "./batchGather.vue?vue&type=script&lang=js&"
export * from "./batchGather.vue?vue&type=script&lang=js&"
import style0 from "./batchGather.vue?vue&type=style&index=0&id=446881ab&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "446881ab",
  null
  
)

export default component.exports